export class DataQueryOperator {

	// Properties
    ID: number;
    OperatorName: string;
    Display: string;
    SqlTemplate: string;
    ReturnTypes: string;
}